module.exports = __webpack_public_path__ + "media/images/icons/country_flags/be-e9ec217e871f35fdde133841df41a071.svg";